import { gaClick } from "@/utils/tracking";

import { useEventListenerEffect } from "./useEventListenerEffect";

function useClickTracking() {
  useEventListenerEffect("click", (event: Event) => {
    const { target } = event;
    if (target && target instanceof HTMLElement) {
      const {
        ga4Click: click,
        ga4EventGroup: eventGroup,
        ga4ClickTarget: clickTarget,
        ga4DeviceCategory: deviceCategory,
        ga4PageType: pageType,
        ga4LinkText,
        ga4LinkUrl,
        ga4Index,
      } = target.dataset;

      if (click && click.endsWith("_click")) {
        const linkText = ga4LinkText || target.innerText;
        const linkUrl =
          ga4LinkUrl ||
          (target instanceof HTMLAnchorElement && target.href) ||
          undefined;
        const index = ga4Index ? +ga4Index : undefined;
        gaClick({
          click,
          clickTarget,
          deviceCategory,
          eventGroup,
          index,
          linkText,
          linkUrl,
          pageType,
        });
      }
    }
  });
}

export { useClickTracking };
